import React from 'react';

interface CountdownIconProps {
  className?: string;
}

export const CountdownIcon: React.FC<CountdownIconProps> = ({ className }) => {
  // Create a 2/3 filled pie chart (240 degrees from 12 o'clock to 8 o'clock)
  // Using SVG path to draw the pie segment
  const radius = 5.5;
  const cx = 8;
  const cy = 8;

  // Calculate the end point of the arc (240 degrees = 4/3 * PI radians)
  // Start at 12 o'clock (270 degrees in standard SVG) and go 240 degrees clockwise
  const startAngle = -90; // 12 o'clock
  const endAngle = startAngle + 240; // 240 degrees clockwise

  const startRad = (startAngle * Math.PI) / 180;
  const endRad = (endAngle * Math.PI) / 180;

  const x1 = cx + radius * Math.cos(startRad);
  const y1 = cy + radius * Math.sin(startRad);
  const x2 = cx + radius * Math.cos(endRad);
  const y2 = cy + radius * Math.sin(endRad);

  // Create the pie slice path
  const piePath = `
    M ${cx} ${cy}
    L ${x1} ${y1}
    A ${radius} ${radius} 0 1 1 ${x2} ${y2}
    Z
  `;

  return (
    <svg
      className={className}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer circle stroke */}
      <circle cx="8" cy="8" r="7" stroke="#6B7280" strokeWidth="1.5" fill="none" />
      {/* Inner pie chart - 2/3 filled (from 12 o'clock to 8 o'clock) */}
      <path d={piePath} fill="#6B7280" />
    </svg>
  );
};

export default CountdownIcon;
